import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import DataTable from "react-data-table-component";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import Popup from "../common/popup";
import CommonAlert from "../common/Commonalert";
import { useTranslation } from "react-i18next";

const Freecode = () => {
  const { t } = useTranslation();
  const [searchTextVal, setSearchTextVal] = useState("");
  const [freecodelist, setFreecodelist] = useState([]);
  const [templist, setTemplist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [freecodevalue, setFreecodevalue] = useState("");
  const [statusChange, setStatusChange] = useState(false);
  const [currentRow, setCurrentRow] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    if (!sessionStorage.getItem("isLoggedIn")) {
      window.location.href = "/";
      return;
    }
    const authData = JSON.parse(sessionStorage.getItem("authData"));
    if (
      authData !== "" &&
      !authData.adminRole.permissions.includes("manage_foodsolutions")
    ) {
      window.location.href = "/unauthorized";
      return;
    }
    getFreecodelist();
  }, []);

  const getFreecodelist = () => {
    const URL = BaseUrl + "admin/freecodelist";
    http
      .get(URL)
      .then((response) => {
        setFreecodelist(response.data.data);
        setTemplist(response.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const deleteFreecode = (value) => {
    setVisibleAlert(true);
    setFreecodevalue(value);
  };

  const deleteFreecodeValue = () => {
    const URL = BaseUrl + `admin/freecode/${freecodevalue._id}`;
    http
      .delete(URL)
      .then((response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const alertPopupclose = () => {
    setVisibleAlert(false);
    setFreecodevalue("");
  };

  const addfreecode = () => {
    window.location.href = "/freesample/freecode/add/";
  };

  const editFreecodeDetails = (freecode) => {
    window.location.href = `/freesample/freecode/edit/${freecode._id}`;
  };

  const handleReset = () => {
    setSearchTextVal("");
    setFreecodelist(templist);
  };

  const handleChange = (value) => {
    setSearchTextVal(value);
    filterData(value);
  };

  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue.length > 0) {
      const result = templist.filter((item) =>
        item.Code.toString().toLowerCase().includes(lowercasedValue),
      );
      setFreecodelist(result);
    } else {
      setFreecodelist(templist);
    }
  };

  const toggleStatus = (row) => {
    setStatusChange(true);
    setCurrentRow(row);
  };

  const confirmStatusChange = () => {
    const updatedStatus = currentRow.FreeCodeStatus === "A" ? "I" : "A";
    const URL = BaseUrl + "admin/freecodestatuschange";
    const payload = {
      Code: currentRow._id,
      Freecodestatus: updatedStatus,
    };
    http
      .post(URL, payload)
      .then((response) => {
        if (response.data.success === true) {
          setFreecodelist((prev) =>
            prev.map((item) =>
              item.Code === currentRow.Code
                ? {
                    ...item,
                    FreeCodeStatus: updatedStatus,
                  }
                : item,
            ),
          );
          setTemplist((prev) =>
            prev.map((item) =>
              item.Code === currentRow.Code
                ? {
                    ...item,
                    FreeCodeStatus: updatedStatus,
                  }
                : item,
            ),
          );
          setStatusChange(false);
          setCurrentRow("");
          setAlertPopup(false);
          setTimeout(() => {
            setAlertMessage(
                t(
                    updatedStatus === "A"
                    ? "free_sample_code_activated"
                    : "free_sample_code_deactivated"
                )
            );
            setAlertPopup(true);
            }, 400);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      name: t("code_txt"),
      selector: (row) => row.Code,
      sortable: true,
    },
    {
      name: t("status_txt"),
      selector: (row) => (row.FreeCodeStatus === "A" ? t("active_txt") : t("inactive_txt")),
      sortable: false,
    },
    {
      name: t("actions_txt"),
      selector: (row) => (
        <div style={{ display: "flex" }}>
          <a
            className="button title-tooltip title-up"
            data-title={t("edit_txt")}
            style={{ color: "white" }}
            onClick={() => editFreecodeDetails(row)}
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </a>
          <a
            className="button title-tooltip title-up"
            data-title={row.FreeCodeStatus === "A" ? t("inactive_txt") : t("active_txt")}
            style={{
              color: "white",
              cursor: "pointer",
            }}
            onClick={() => toggleStatus(row)}
          >
            <i
              className={
                row.FreeCodeStatus === "A" ? "fa fa-unlock" : "fa fa-lock"
              }
              aria-hidden="true"
            ></i>
          </a>
          <a
            className="button title-tooltip title-up"
            data-title={t("delete_txt")}
            style={{ color: "white" }}
            onClick={() => deleteFreecode(row)}
          >
            <i className="fa fa-trash" aria-hidden="true"></i>
          </a>
        </div>
      ),
      sortable: false,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <>
      <div className="dashboard-block">
        {alertPopup && (
        <CommonAlert
            title={t("alert_txt")}
            message={alertMessage}
            onClose={() => {
                setAlertPopup(false);
                setAlertMessage("");
            }}
        />
        )}
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">{t("free_sample_code_txt")}</h1>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("search_by_code_txt")}
                      />
                    </div>
                    <button
                      className="submitbtn button search-holi-btn"
                      onClick={() => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                    <button
                      className="resetbtn"
                      type="reset"
                      onClick={handleReset}
                    >
                      {t("reset_txt")}
                    </button>
                  </div>
                  <div className="add-holidaybtn">
                    <button className="addbtn" onClick={addfreecode}>
                      {t("add_txt")}
                    </button>
                  </div>
                </div>
                <div className="table_overflow">
                  <DataTable
                    columns={columns}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_freecode_matching_txt")}
                      </div>
                    }
                    data={freecodelist}
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={paginationComponentOptions}
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
      {visibleAlert && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("confirm_delete_txt")}</p>
                <div className="alert-buttons">
                  <a
                    title={t("ok_txt")}
                    onClick={deleteFreecodeValue}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    title={t("cancel_txt")}
                    onClick={alertPopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {statusChange && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>
                    {t(
                        currentRow.FreeCodeStatus === "A"
                        ? "confirm_deactivate_code"
                        : "confirm_activate_code"
                    )}
                </p>
                <div className="alert-buttons">
                  <a
                    title={t("ok_txt")}
                    onClick={confirmStatusChange}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    onClick={() => {
                      setStatusChange(false);
                      setCurrentRow("");
                      setAlertPopup(false);
                      setAlertMessage("");
                    }}
                    title={t("cancel_txt")}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Freecode;